import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import IdleLogOut from './IdleLogOut'

import { resetApp } from 'src/modules/App/actions'
import { resetUser } from 'src/modules/Users/actions'

const mapStateToProps = state => {
  return {
    user: state.user.user,
    userLastAccessType: state.user.userLastAccessType,
    isWidgetState: state.appReducer.isWidget,
  }
}

const mapDispatchToProps = {
  resetApp,
  resetUser,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(IdleLogOut))
